import Meta from '@/components/common/Meta'

import CollegeShippingStorageMovingServicesPage from '@/v2/components/pages/landing-pages/college-shipping-storage-moving-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import {
  metaImages,
  ogImages,
  faqSectionContent
} from '@/v2/constants/pages/landing-pages/college-shipping-storage-moving-services-page'

interface CollegeShippingStorageMovingServicesPageProps {}

const Page: React.FC<CollegeShippingStorageMovingServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.college_shipping_storage_moving_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.college_shipping_storage_moving_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.college_shipping_storage_moving_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <CollegeShippingStorageMovingServicesPage />
    </>
  )
}

export default Page
